import { useSelector } from "react-redux";
import Chat from "../../components/chat";
import { Tab, Tabs, Typography } from "@mui/material";

const ConversationChat = () => {
    const assistant = useSelector((state) => state.assistant.dados);

    return <div className="w-full">
        <div className="w-full border-divider flex flex-row items-center justify-center">
            <Tabs value={0} sx={{ color: 'black', marginBottom: 3 }}>
                <Tab style={{ fontWeight: 550, fontSize: 15, color: 'black' }} label={<Typography className="text-gray-700 dark:text-gray-300 mb-2 font-bold">{assistant.name}</Typography>} wrapped />
            </Tabs>
        </div>

        <Chat />
    </div>
}

export default ConversationChat;